/** @format */

export const PRODUCT_LIST_HEADER_TEXT = {
  semanticTitle: (searchTerm: string) => `Here's what we found for "${searchTerm}"`,
  semanticSubtext: 'Showing additional products that closely match your search.',
  fuzzyTitle: (searchTerm: string) => `We couldn't find exact results for "${searchTerm}"`,
  fuzzySubtext: 'You might like these similar items.',
  dsgZeroResultsTitle: 'We Struck Out',
  standardTitle: (totalCount: number, searchTerm: string) =>
    `${totalCount > 1 ? totalCount + ' results' : '1 result'} for "${searchTerm}"`,
  standardZeroResultsTitle: (searchTerm: string) => `No results for "${searchTerm}"`,
  zeroResults: {
    message: "We're sorry, we did not find any matches.",
    suggestion: 'Please check for any spelling errors or try more general keywords.',
  },
};
